import { FC } from 'react';
import stylex from '@stylexjs/stylex';
import { TrashIcon } from '@shared/assets/icons';
import InputClearable from '@shared/ui/input-clearable';
import { IconButton } from '@shared/ui/icon-button';
import type { GuestInfo, FieldInfo } from '@entities/leadCollector';
import { FIELD_ID_PHONE, FIELD_ID_EMAIL } from '@entities/leadCollector';
import { styles } from '../../MainGuestTab/styles';

const getPlaceholder = (fieldInfo: FieldInfo, isPhone: boolean, isEmail: boolean): string => {
  if (isPhone) return '+ 7 (000) 000-00-00';
  if (isEmail) return 'Укажите e-mail';
  return fieldInfo.placeholder || '';
};

export interface ExtraGuestFormRowProps {
  guestInfo: GuestInfo;
  title: string;
  type: 'adult' | 'child';
  guestIndex: number;
  onUpdate: (guestIndex: number, instanceId: string, value: string, error?: string) => void;
  onRemove: () => void;
  onPhoneChange: (type: 'adult' | 'child', index: number, instanceId: string, value: string) => void;
}

export const ExtraGuestFormRow: FC<ExtraGuestFormRowProps> = ({
  guestInfo,
  title,
  type,
  guestIndex,
  onUpdate,
  onRemove,
  onPhoneChange,
}) => {
  const updateField = (instanceId: string, value: string, error = '') => onUpdate(guestIndex, instanceId, value, error);
  const handlePhone = (instanceId: string, value: string) => onPhoneChange(type, guestIndex, instanceId, value);

  const renderField = (fieldInfo: FieldInfo) => {
    const isPhone = fieldInfo.dbField === FIELD_ID_PHONE;
    const isEmail = fieldInfo.dbField === FIELD_ID_EMAIL;
    const label = fieldInfo.label || fieldInfo.placeholder || fieldInfo.dbField;
    const status: 'error' | undefined = fieldInfo.error ? 'error' : undefined;
    const changeFunction = (inputValue: string) => {
      if (isPhone) handlePhone(fieldInfo.instanceId, inputValue);
      else updateField(fieldInfo.instanceId, inputValue);
    };

    const common = {
      status,
      size: 'small' as const,
      settings: { width: '252px' },
      value: fieldInfo.value,
      changeFunction,
      clearHandler: () => updateField(fieldInfo.instanceId, ''),
    };
    const placeholder = getPlaceholder(fieldInfo, isPhone, isEmail);
    return (
      <div key={fieldInfo.instanceId}>
        <div {...stylex.props(styles.fieldWithLabel)}>
          <span {...stylex.props(styles.fieldLabel)}>{label}</span>
          <InputClearable {...common} placeholder={placeholder} inputMessage={fieldInfo.error} />
        </div>
      </div>
    );
  };

  const fio = guestInfo.FIO ?? [];
  const additionalFields = guestInfo.additionalFields ?? [];
  const allFieldsInOrder = [...fio, ...additionalFields];

  return (
    <div {...stylex.props(styles.adultCont)}>
      <div {...stylex.props(styles.adultCont1)}>
        <div {...stylex.props(styles.adultTitle)}>
          <div {...stylex.props(styles.adultTitleText)}>{title}</div>
        </div>
        <div {...stylex.props(styles.adultInputContainer)}>
          <div {...stylex.props(styles.adultInputContent)}>
            {!!allFieldsInOrder.length && (
              <div {...stylex.props(styles.fieldRow, styles.fieldRowColumnGap20)}>
                {allFieldsInOrder.map(renderField)}
              </div>
            )}
          </div>
          <div {...stylex.props(styles.adultInputContentCard)}>
            <div {...stylex.props(styles.iconContainer)}>
              <IconButton icon={<TrashIcon color="currentColor" />} onClick={onRemove} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
